import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Bell } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { useApp } from "@/context/AppContext";
import { api } from "@/lib/api";

export const NotificationBell = () => {
  const { t, lang, me, refreshMe, demoUser } = useApp();
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  useEffect(() => { if (open) api.get("/me/notifications").then((r) => setItems(r.data)).catch(() => setItems([])); }, [open, demoUser]);
  const unread = me?.unread_notifications || 0;
  const markRead = async () => { await api.post("/me/notifications/read"); refreshMe(); setItems((x) => x.map((n) => ({ ...n, read: true }))); };
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button data-testid="notifications-bell-btn" aria-label={`${t("notifications")} (${unread})`} className="relative flex h-11 w-11 items-center justify-center rounded-full hover:bg-white/10">
          <Bell size={20} />
          {unread > 0 && <span data-testid="notifications-unread-count" className="absolute end-1.5 top-1.5 min-w-[18px] rounded-full bg-[#B8901F] px-1 text-[10px] font-bold leading-[18px] text-white">{unread}</span>}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 p-0" data-testid="notifications-popover">
        <div className="flex items-center justify-between border-b px-3 py-2">
          <span className="text-sm font-semibold">{t("notifications")}</span>
          <button data-testid="notifications-mark-read-btn" onClick={markRead} className="text-xs font-semibold text-primary">{t("markRead")}</button>
        </div>
        <div className="q1-scroll max-h-72 overflow-y-auto">
          {items.length === 0 && <p className="p-4 text-center text-xs text-muted-foreground">{t("noNotifications")}</p>}
          {items.map((n) => (
            <Link key={n.id} to={`/requests/${n.ref}`} onClick={() => setOpen(false)} className="block border-b px-3 py-2.5 text-xs hover:bg-muted">
              <span className="flex items-center gap-1.5 font-semibold">{!n.read && <span className="h-2 w-2 rounded-full bg-primary" aria-label="unread" />}{lang === "ar" ? n.title_ar : n.title_en}</span>
              <span className="text-muted-foreground">{new Date(n.at).toLocaleString()} · {n.channel}</span>
            </Link>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
};
